module.exports = __webpack_public_path__ + "img/cropped-logo-K-NETT.03f3021b.png";